<script>
import Multiselect from "@vueform/multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/router/views_mobagile/components/loader.vue";
import api from "@/axios";
import moment from "moment/moment";
import { useMagicKeys, whenever } from '@vueuse/core'
import Swal from "sweetalert2";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Venda (PDV)",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {Loader, Layout, PageHeader, Multiselect  },
  data() {
    return {
      title: "Movimentos PDV",
      items: [
        {
          text: "Movimentos PDV",
          href: "/movspdv/list",
        },
        {
          text: "Venda (PDV)",
          active: true
        }
      ],

      idData: 0,
      movPdvData: {
        'status': 'EL',
        'valorliq': 0
      },
      movPdvItemData: {},
      tabPrecosData: {},
      produtoPesqData: {},
      produtoSelData: {},

      clienteData: {
        'nome': 'Consumidor Final',
        'tipo': 'PF'
      },

      dtlistPesqProduto: null,
      loadingPesqProd: null,


      updating: true,
      submitted: false,
      errosValid: null,
      tabPrecoSelecionada: null,

      leitorCodBar: 'A',

      updatingPdvItens: null,
      movPdvItensData: null,

      dtlistPesqCliente: null,


      condPgtoData: {},
      dtlistPesqCondPgto: null,
      formaPgtoData: {},
      dtlistPesqFormaPgto: null,

      condPgtosData: {},
      formasPgtoData: {},

      showModalCCaixa: false,
      contaCaixaData: {},
      tabIndex: 0,

      imgProduto: null

    }
  },
  created() {



  },
  mounted() {
    const keys = useMagicKeys()

    whenever(keys.alt_s, () => {
      this.$refs.inputPesqProd.focus()
    })

    whenever(keys.alt_r, () => {
      this.reiniciar()
    })

    whenever(keys.alt_z, () => {
      this.finalizar()
    })
    console.log('mounted_pdv_index')
    let rota = this.$route.path
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra){
      if (parseInt(rota.substring(ultimaBarra + 1))){
        this.idData = parseInt(rota.substring(ultimaBarra + 1))
        this.title = `Editando Movimento PDV (${this.idData})`
      } else {
        this.title = `Criando Movimento PDV`
      }

    }
    console.log(`idData: ${this.idData}`)
    // if (this.idData > 0){
    //   this.carregarDados()
    // }else{
    //   this.title = `Venda (PDV)`
    //   this.updating = false
    // }

    this.carregarDados()

  },


  methods: {

    finalizarVenda() {
      console.log('finalizarVenda')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Finalizar Cupom Fiscal",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          api.post(`${getBaseUrl()}api/movpdvfina`, {
            'iddata': this.idData
          }).then((res) => {
            console.log('then axios')
            console.log(res)
            // this.produtoData = res.data[0]
            // this.loadingList = false
            this.showAssocRoma = false
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Movimento finalizado com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })

            this.$router.replace('/movpdv/editar/0')
            this.idData = 0
            this.title = `Criando Movimento PDV`
            this.carregarDados()



          })
        }
      })
    },

    excluirVenda() {
      console.log('excluirVenda')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Cancelar Cupom Fiscal",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          api.post(`${getBaseUrl()}api/movpdvcanc`, {
            'iddata': this.idData
          }).then((res) => {
            console.log('then axios')
            console.log(res)
            // this.produtoData = res.data[0]
            // this.loadingList = false
            this.showAssocRoma = false
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Movimento finalizado com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
            this.movPdvData = res.data[0]
          })
        }
      })
    },


    nomeStatus(strEntr){
      let result = strEntr
      switch (strEntr) {
        case 'AB':
          result = 'Aberto'
          break
        case 'FC':
          result = 'Fechado'
          break
      }
      return result
    },


    abrirNovoCaixa() {
      console.log('abrirNovoCaixa')
      api.post(`${getBaseUrl()}api/movpdvabcaixa`, {
        'iddata': this.idData
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        // this.produtoData = res.data[0]
        // this.loadingList = false
        this.showAssocRoma = false
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
        this.showModalCCaixa = false
        this.contaCaixaData = res.data[0]
        if (res.data[1]) {
          this.movPdvData = res.data[1]
        }
      })
    },



    fecharCaixa() {
      console.log('fecharCaixa')
      this.showModalCCaixa = false

      Swal.fire({
        position: "center",
        icon: "question",
        title: `Fechar Caixa (${this.contaCaixaData.id})`,
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          api.post(`${getBaseUrl()}api/movpdvfccaixa`, {
            iddata: this.contaCaixaData.id
          }).then((res) => {
            console.log('then axios')
            console.log(res)
            this.showModalCCaixa = false
            this.contaCaixaData = res.data[0]
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações salvas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
          })
        }
      })
    },


    pesqCliente(evt){
      console.log('pesqCliente')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/clipesq`, {
          params: { q: query, c: 'CL' }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtlistPesqCliente = res.data
        });
      }
    },

    escolheuCliente(){
      console.log('escolheuCliente')
      this.dtlistPesqCliente.forEach((cliente) => {
        // console.log('value')
        // console.log(cliente.codigo)
        if (cliente.codigo === this.movPdvData.cliente) {
          console.log('clienteSel')
          console.log(cliente)
          this.clienteData = cliente
        }
      })

      api.post(`${getBaseUrl()}api/movpdvcli`, {
        'iddata': this.idData,
        'movcli': this.movPdvData.cliente
      }).then((res) => {
        console.log('then axios alteracli')
        console.log(this.idData)
        console.log(res.data)

        if (this.idData === 0){
          this.idData = res.data[0].id
          this.$router.replace('/movpdv/editar/' + this.idData)
        }
      })
    },



    pesqCondPgto(evt){
      console.log('pesqCondPgto')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/cpgtopesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtlistPesqCondPgto = res.data
        });
      }
    },

    escolheuCondPgto(){
      console.log('escolheuCondPgto')
      this.dtlistPesqCondPgto.forEach((condicao) => {
        // console.log('value')
        // console.log(condicao.codigo)
        if (condicao.codigo === this.movPdvData.condpgto) {
          console.log('condicaoSel')
          console.log(condicao)
          this.condPgtoData = condicao
          api.post(`${getBaseUrl()}api/movpdvcond`, {
            'iddata': this.idData,
            'movcond': this.movPdvData.condpgto
          }).then((res) => {
            console.log('then axios alteracond')
            console.log(this.idData)
            console.log(res.data)
          })
        }
      })
    },

    pesqFormaPgto(evt){
      console.log('pesqFormaPgto')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/fpgtopesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtlistPesqFormaPgto = res.data
        });
      }
    },

    escolheuFormaPgto(){
      console.log('escolheuFormaPgto')
      this.dtlistPesqFormaPgto.forEach((forma) => {
        // console.log('value')
        // console.log(forma.codigo)
        if (forma.codigo === this.movPdvData.formapgto) {
          console.log('formaSel')
          console.log(forma)
          this.formaPgtoData = forma
          api.post(`${getBaseUrl()}api/movpdvforma`, {
            'iddata': this.idData,
            'movforma': this.movPdvData.formapgto
          }).then((res) => {
            console.log('then axios alteraforma')
            console.log(this.idData)
            console.log(res.data)
          })
        }
      })
    },



    excluirItem(idItem){

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {
          this.updatingPdvItens = true

          api.delete(`${getBaseUrl()}api/movpdvitem`, {
            params: {
              'iddata': idItem
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)

            this.movPdvData = res.data[0]
            this.movPdvItensData = res.data[1]

            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })

            this.updatingPdvItens = false

          })



        }
      })
    },


    confirmouQuant() {
      console.log('confirmouQuant')
      console.log(this.movPdvData)
      if (this.contaCaixaData && this.contaCaixaData.id) {
        this.updatingPdvItens = true
        api.post(`${getBaseUrl()}api/movpdvitem`, {
          'iddata': this.idData,
          'idcaixa': this.contaCaixaData.id,
          'item': this.produtoSelData,
          'tab': this.tabPrecoSelecionada,
          'movcli': this.movPdvData.cliente,
          'movcond': this.movPdvData.condpgto,
          'movforma': this.movPdvData.formapgto,
        }).then((res) => {
          console.log('then axios confitem')
          console.log(this.idData)
          console.log(res.data)
          this.updatingPdvItens = false
          if (this.idData === 0){
            this.idData = res.data[1].id
            this.$router.replace('/movpdv/editar/' + this.idData)
            this.title = `Editando Movimento PDV (${this.idData})`
          }
          this.movPdvItensData = res.data[0]
          this.movPdvData = res.data[1]
          this.produtoSelData = {}
          this.produtoPesqData = null
          this.dtlistPesqProduto = null
          this.updatingPdvItens = false
          this.$refs.inputPesqProd.focus()
        })
      } else {

        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Caixa não definido, favor clicar em Escolher Caixa.",
          showConfirmButton: false,
          timer: 1500
        })

      }
    },



    calculaTotal(){

      let quant = this.produtoSelData.qtd
      let desconto = this.produtoSelData.desconto
      let preco = this.produtoSelData.preco
      // let percDesc = 0

      if (quant > 0 && preco > 0){

        let valorTotalItemBrt = quant * preco
        console.log('valorTotalItem')
        console.log(valorTotalItemBrt)

        // if (vlrUnit !== vlrUnitTab){
        // percDesc = (1 - (vlrUnit / vlrUnitTab)) * 100
        // }

        this.produtoSelData.vlrtotalbrt = valorTotalItemBrt

        let valorTotalItemLiq = 0
        if (desconto && desconto !== 0) {
          valorTotalItemLiq = valorTotalItemBrt - (valorTotalItemBrt * desconto / 100)
        } else {
          valorTotalItemLiq = valorTotalItemBrt
        }


        this.produtoSelData.vlrunitliq = valorTotalItemLiq / quant
        this.produtoSelData.vlrtotalliq = valorTotalItemLiq
      }

    },

    // calculaTotalMov(){
    //   console.log('calculaTotalMov')
    //   console.log(this.movPdvData.valorliq)
    //   console.log(this.movPdvData.valorfrt)
    //
    //   let valliq = 0
    //   if (this.movPdvData.valorliq){
    //     valliq = this.movPdvData.valorliq
    //   }
    //
    //
    //   this.movPdvData.valortotal = valliq + this.movPdvData.valorfrt
    //
    // },


    pesqProduto(evt){
      console.log('pesqProduto')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.dtlistPesqProduto = null
        this.loadingPesqProd = true
        api.get(`${getBaseUrl()}api/prodpesqtd`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          // //console.log(res.data.length)
          this.dtlistPesqProduto = res.data
          this.dtlistPesqProduto.forEach((value) => {
            if (value.imgs){
              let imgTrat = value.imgs.split(',')
              value.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`
            }
            value['descrcodigo'] = value['codigo'] + ' ' + value['descricao'] + ' ' + value['codbarra']
          })
        })
      }
    },


    escolheuProduto(){
      console.log('escolheuProduto')
      console.log(this.produtoPesqData)

      this.dtlistPesqProduto.forEach((produto) => {
        // console.log('value')
        // console.log(produto.codigo)
        if (produto.codigo === this.produtoPesqData) {
          console.log('produtoSel')
          console.log(produto)
          this.produtoSelData = produto
          this.produtoSelData.vlrunitbrt = produto.preco
          this.produtoSelData.qtd = 1
          api.get(`${getBaseUrl()}api/prodimg`, {
            responseType: 'blob',
            params: { 'iddata': produto.id }
          }).then((resImg) => {
            console.log('res down')
            console.log(resImg)
            this.imgProduto = URL.createObjectURL(resImg.data)
          })
          this.$refs.quantidade.focus()
        }
      })

    },


    alteraTabelaSelected() {
      console.log('alteraTabelaSelected')

    },




    carregarDados(){
      this.updating = true
      console.log('carregarDados')

      api.get(`${getBaseUrl()}api/movpdv`, {
        params: {
          iddata: this.idData
        }
      }).then((res) => {
        console.log('then axios indexpdv')
        console.log(res.data)

        this.tabPrecosData = res.data[0]
        this.tabPrecoSelecionada = this.tabPrecosData[0].codigo
        this.movPdvData = res.data[1]
        this.movPdvItensData = res.data[2]
        this.clienteData = res.data[3]
        this.condPgtoData = res.data[4]
        this.formaPgtoData = res.data[5]


        if (this.clienteData) {
          this.movPdvData.cliente = this.clienteData.codigo
          this.dtlistPesqCliente = [
            {
              'codigo': this.clienteData.codigo,
              'nome': this.clienteData.nome
            },
          ]
        }

        if (this.condPgtoData) {
          this.movPdvData.condpgto = this.condPgtoData.codigo
          this.dtlistPesqCondPgto = [
            {
              'codigo': this.condPgtoData.codigo,
              'descricao': this.condPgtoData.descricao
            },
          ]
        }

        if (this.formaPgtoData) {
          this.movPdvData.formapgto = this.formaPgtoData.codigo
          this.dtlistPesqFormaPgto = [
            {
              'codigo': this.formaPgtoData.codigo,
              'descricao': this.formaPgtoData.descricao
            },
          ]
        }

        if (res.data[6]) {
          this.condPgtosData = res.data[6]
          this.dtlistPesqCondPgto = this.condPgtosData
        }

        if (res.data[7]) {
          this.formasPgtoData = res.data[7]
          this.dtlistPesqFormaPgto = this.formasPgtoData
        }

        if (res.data[8]) {
          this.contaCaixaData = res.data[8]
        }

        if (this.movPdvData.status !== 'EL') {
          this.tabIndex = 1
        }


        this.$refs.inputPesqProd.focus()

        //
        // this.idData = this.movInventData.id
        // this.title = `Editar Inventário (${this.movInventData.id})`
        this.updating = false
      })
    },




    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  },

  watch: {
    'produtoSelData.qtd': {
      handler() {
        this.calculaTotal()
      }
    },
    'produtoSelData.desconto': {
      handler() {
        this.calculaTotal()
      }
    },

  },

};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" :status="movPdvData.status"/>

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <div class="row">


      <div class="col-xl-6" >
        <div class="card">
          <div class="card-body">
            <b-tabs
                content-class="p-6"
                class="pt-2"
                nav-wrapper-class="nav-item"
                v-model="tabIndex"
                nav-class="justify-content-center nav-tabs-custom"
            >
              <b-tab title="Produto (Shift+Z)"

                     >
                <div v-if="movPdvData.status === 'EL'">
                  <div class="row justify-content-center">


                    <div class="row mt-3">


<!--                      <div class="col-sm-6">-->
<!--                        <div class="mb-3">-->
<!--                          <label for="tabpreco">Tabela de Preço</label>-->
<!--                          <select-->
<!--                              id="tabpreco"-->
<!--                              v-model="tabPrecoSelecionada"-->
<!--                              class="form-control">-->
<!--                            <option value="01">Tabela Preços 001</option>-->
<!--                            <option value="02">Tabela Preços 002</option>-->
<!--                          </select>-->

<!--                        </div>-->
<!--                      </div>-->

                      <div class="col-sm-5">
<!--                        <div class="search-box me-2 mb-2 d-inline-block">-->
<!--                          <div class="position-relative" >-->
<!--                            <select-->
<!--                                id="selectTronco"-->
<!--                                v-model="tabPrecoSelecionada"-->
<!--                                @change="alteraTabelaSelected"-->
<!--                                class="form-control select2-search-disable">-->
<!--                              <option v-for="(item, index) in tabPrecosData"-->
<!--                                      :value="item.codigo"-->
<!--                                      :key="index">-->
<!--                                {{ item.descricao }}-->
<!--                              </option>-->

<!--                            </select>-->
<!--                            <i class="bx bx-filter-alt search-icon"></i>-->
<!--                          </div>-->
<!--                        </div>-->
                      </div>



                      <div class="col-sm-6" >
                        <div class="mb-3 align-items-end align-content-end float-end">
                          <h5 class="font-size-14">Leitor de código de barras</h5>
                          <b-form-checkbox
                              switch size="lg"
                              value="A"
                              unchecked-value="I"
                              v-model="leitorCodBar">
                            {{ leitorCodBar === 'A' ? 'Ativado' : 'Desativado' }}
                          </b-form-checkbox>
                        </div>
                      </div>


<!--                      <div class="col-sm-4">-->
<!--                        <div class="mb-3">-->
<!--                          <label for="nome">Nome</label>-->
<!--                          <input-->
<!--                              id="nome"-->
<!--                              v-model="clienteData.nome"-->
<!--                              type="text"-->
<!--                              class="form-control"-->
<!--                              placeholder="Nome"-->
<!--                              :class="{'is-invalid': submitted && !clienteData.nome}"/>-->
<!--                          <div v-if="submitted && !clienteData.nome"-->
<!--                               class="invalid-feedback">-->
<!--                            <span>Campo nome obrigatório, favor preencher.</span>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->


                    </div>

                    <div class="row">

<!--                      <div class="col-sm-12">-->
<!--                        <div class="mb-3">-->
<!--                          <label for="produtopesq">Produto</label>-->
<!--                          <input-->
<!--                              id="produtopesq"-->
<!--                              v-model="produtoPesq"-->
<!--                              type="text"-->
<!--                              class="form-control"-->
<!--                              placeholder="Pesquisar produto"/>-->
<!--                        </div>-->
<!--                      </div>-->

<!--                      <div class="search-box mb-2 me-2">-->
<!--                        <div class="position-relative">-->
<!--                          <input-->
<!--                              ref="inputPesqProd"-->
<!--                              id="inputPesquisa"-->
<!--                              type="text"-->
<!--                              class="form-control bg-light border-light rounded"-->
<!--                              placeholder="Pesquisar produto..."-->
<!--                          />-->
<!--                          <i class="bx bx-search-alt search-icon"></i>-->
<!--                        </div>-->
<!--                      </div>-->


                      <div class="col-md-12">
                        <div class="mb-3">
                          <multiselect id="produtoPesq"
                                       ref="inputPesqProd"
                                       @search-change="pesqProduto"
                                       @select="escolheuProduto"
                                       v-model="produtoPesqData"
                                       placeholder="Pesquisar produto"
                                       :options="dtlistPesqProduto"
                                       :searchable="true"
                                       label="descricao"
                                       class="multiselect-size form-control bg-light border-light rounded"
                                       track-by="descrcodigo"
                                       value-prop="codigo">
                            <template #option="slotProps" v-if="dtlistPesqProduto">
                              <div class="row" style="min-width: 100%;">

                                <div style="min-width: 100%;">
                                  <span class="text-info">
                                    {{ slotProps.option.codigo }}
                                  </span>
                                  <span class="mx-4" >
                                    {{ slotProps.option.unidade }}
                                  </span>
                                  <span class="float-end text-warning" >
                                    R$ {{ formatDecimal(slotProps.option.preco) }}
                                  </span>

                                </div>

                                <div class="col-12">
                                <span class="mt-5 font-size-15">
                                  {{ slotProps.option.descricao }}
                                </span>
                                  <span class="float-end" >

                                  </span>
                                </div>

                                <div class="align-items-end text-end align-content-end float-end">
                                  <div v-if="!slotProps.option.img1" class="avatar-xs">
                                    <span class="avatar-title rounded-circle">{{ slotProps.option.id }}</span>
                                  </div>
                                  <div v-if="slotProps.option.img1">
                                    <img class="rounded-circle avatar-xs" :src="slotProps.option.img1" alt />
                                  </div>

                                  <span class="float-end ">
                                  <span v-if="slotProps.option.saldo > 0" class="avatar-title rounded-circle bg-success avatar-xs p-1">
                                    <span class="">{{ formatInteger(slotProps.option.saldo) }}</span>
                                  </span>

                                  <span v-else class="avatar-title rounded-circle bg-danger avatar-xs p-1">
                                    <span class="">{{ formatInteger(slotProps.option.saldo) }}</span>
                                  </span>

                                   </span>
                                </div>


                              </div>
                            </template>
                          </multiselect>
                        </div>
                      </div>



                    </div>

                    <div class="row">

                      <div class="row align-items-center">

                        <div class="col-md-6" style="min-height: 200px;">

                          <img :src="imgProduto"
                               v-if="produtoSelData.id"
                               alt
                               class="img-fluid mx-auto d-block"
                          />
                        </div>

                        <div class="col-md-6">
                          <div class="text-center text-md-start pt-3 pt-md-0">

                            <h5 class="mb-3 text-truncate">
                              <a href="javascript: void(0);" class="text-dark text-wrap">
                                {{ produtoSelData.codigo }} - <h1> {{ produtoSelData.descricao }} </h1>
                              </a>
                            </h5>

                            <h5 class="my-0">
                              <b>R$ {{ formatDecimal(produtoSelData.preco) }}</b>
                            </h5>

                          </div>
                        </div>
                      </div>

                      <div class="row">

                        <div class="col-sm-3">
                          <div class="mb-3 text-end">
                            <label for="quantidade">Quantidade</label>
                            <input
                                id="quantidade"
                                ref="quantidade"
                                v-model="produtoSelData.qtd"
                                type="number"
                                @keypress.enter="confirmouQuant"
                                class="form-control"
                                placeholder="Quantidade"/>
                          </div>
                        </div>


                        <div class="col-sm-3">
                          <div class="mb-3 text-end">
                            <label for="desconto">Desconto</label>
                            <input
                                id="desconto"
                                v-model="produtoSelData.desconto"
                                type="number"
                                class="form-control"
                                placeholder="Desconto"/>
                          </div>
                        </div>


                        <div class="col-sm-3">
                          <div class="mb-3 text-end">
                            <label for="vlrunitbrt">Valor Unitário</label>
                            <input
                                id="vlrunitbrt"
                                v-model="produtoSelData.vlrunitbrt"
                                type="number"
                                :disabled="true"
                                class="form-control"
                                placeholder="Valor Unitário"/>
                          </div>
                        </div>

                        <div class="col-sm-3">
                          <div class="mb-3 text-end">
                            <label for="vlrunitbrt">Sub total</label>
                            <input
                                id="vlrunitbrt"
                                v-model="produtoSelData.vlrtotalliq"
                                type="number"
                                :disabled="true"
                                class="form-control"
                                placeholder="Sub total"/>
                          </div>
                        </div>

                      </div>

                      <div class="row">

                        <div class="col-sm-9">
                          <label for="obsitem">Observações</label>
                          <textarea
                              id="obsitem"
                              v-model="produtoSelData.obs"
                              type="text"
                              rows="2"
                              class="form-control"
                              placeholder="Observações"/>
                        </div>

<!--                        <div class="col-sm-4 text-center">-->




<!--                        </div>-->

                        <div class="col-sm-3 mt-5">

                          <div class="float-end">

                            <button class="btn btn-success"
                                    @click="confirmouQuant"
                                    :disabled="!produtoSelData.id">
                              <i class="mdi mdi-check me-1"></i> Inserir Produto na Venda
                            </button>

                          </div>

                        </div>
                      </div>



                    </div>



                  </div>
                </div>
              </b-tab>


              <b-tab title="Cliente (Shift+C)">
                <div>
                  <div class="row justify-content-center">
                    <div class="row mt-3">
                    </div>
                    <div class="row mt-3">

                      <div class="col-md-8">
                        <div class="mb-3">
                          <label for="clientePesq">Cliente</label>

                          <multiselect id="clientePesq"
                                       ref="inputPesqCliente"
                                       @search-change="pesqCliente"
                                       @select="escolheuCliente"
                                       v-model="movPdvData.cliente"
                                       placeholder="Pesquisar cliente"
                                       :options="dtlistPesqCliente"
                                       :searchable="true"
                                       :disabled="movPdvData.status !== 'EL' || !movPdvData.id || !movPdvData.id === 0"
                                       label="nome"
                                       class="multiselect-size form-control bg-light border-light rounded"
                                       track-by="nome"
                                       value-prop="codigo">
                            <template #option="slotProps" v-if="dtlistPesqCliente">
                              <div class="row">
                                <div>
                                  <span class="text-info">
                                    {{ slotProps.option.codigo }}
                                  </span>
                                  <span class="mx-4" >
                                    {{ slotProps.option.cnpj }}
                                  </span>
                                </div>
                                <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                                <div class="align-items-end text-end align-content-end">{{ slotProps.option.cidade }} - {{ slotProps.option.estado }}</div>
                              </div>
                            </template>
                          </multiselect>
                        </div>
                      </div>

                      <div class="col-sm-4">
                        <div class="mb-3">
                          <label for="tipocli">Tipo</label>
                          <select
                              id="tipocli"
                              v-model="clienteData.tipo"
                              :disabled="true"
                              class="form-control">
                            <option value="PF" selected>Pessoa Física</option>
                            <option value="PF">Pessoa Jurídica</option>
                          </select>

                        </div>
                      </div>


                    </div>

                    <div class="row mt-3">

                      <div class="col-sm-5">
                        <div class="mb-3">
                          <label for="cnpjcli">CPF / CNPJ</label>
                          <input
                              id="cnpjcli"
                              v-model="clienteData.cnpj"
                              type="text"
                              class="form-control"
                              :disabled="true"
                              placeholder="CPF / CNPJ"/>
                        </div>
                      </div>

                      <div class="col-sm-3">
                        <div class="mb-3">
                          <label for="codigo">Código</label>
                          <input
                              id="codigo"
                              v-model="clienteData.codigo"
                              type="text"
                              class="form-control"
                              :disabled="true"
                              placeholder="Código"/>
                        </div>
                      </div>

                      <div class="col-sm-4">
                        <div class="mb-3">
                          <label for="fantasia">Fantasia</label>
                          <input
                              id="fantasia"
                              v-model="clienteData.fantasia"
                              type="text"
                              class="form-control"
                              :disabled="true"
                              placeholder="Fantasia"/>
                        </div>
                      </div>

                    </div>


                    <div class="row mt-4">

                      <b-card-header header-tag="header" role="tab">
                        <h6 class="m-0">
                          <a
                              v-b-toggle.accordion-7
                              class="text-dark"
                              href="javascript: void(0);"
                          >Informações Adicionais</a>
                        </h6>
                      </b-card-header>
                      <b-collapse id="accordion-7" accordion="my-accordion-7" role="tabpanel">
                        <b-card-body>



                          <div class="row mb-2">

                            <div class="col-md-4">
                              <label for="inscricao">Inscrição</label>
                              <div class="position-relative">
                                <input
                                    id="inscricao"
                                    type="text"
                                    v-model="clienteData.inscricao"
                                    class="form-control"
                                    :disabled="true"
                                    placeholder="Inscrição"/>
                              </div>
                            </div>


                            <div class="col-md-4">
                              <label for="contrib">Contribuinte</label>
                              <div class="position-relative">
                                <input
                                    id="contrib"
                                    type="text"
                                    v-model="clienteData.contrib"
                                    class="form-control"
                                    :disabled="true"
                                    placeholder="Contribuinte"/>
                              </div>
                            </div>


                            <div class="col-md-4">
                              <label for="rg">RG</label>
                              <div class="position-relative">
                                <input
                                    id="rg"
                                    type="text"
                                    v-model="clienteData.rg"
                                    class="form-control"
                                    :disabled="true"
                                    placeholder="RG"/>
                              </div>
                            </div>


                          </div>

                          <div class="row mb-2">


                            <div class="col-md-4">
                              <label for="cep">CEP</label>
                              <div class="position-relative">
                                <input
                                    id="cep"
                                    type="text"
                                    v-model="clienteData.cep"
                                    class="form-control"
                                    :disabled="true"
                                    placeholder="CEP"/>
                              </div>
                            </div>

                            <div class="col-md-4">
                              <label for="cidade">Cidade</label>
                              <div class="position-relative">
                                <input
                                    id="cidade"
                                    type="text"
                                    v-model="clienteData.cidade"
                                    class="form-control"
                                    :disabled="true"
                                    placeholder="Cidade"/>
                              </div>
                            </div>

                            <div class="col-md-4">
                              <label for="estado">Estado</label>
                              <div class="position-relative">
                                <input
                                    id="estado"
                                    type="text"
                                    v-model="clienteData.estado"
                                    class="form-control"
                                    :disabled="true"
                                    placeholder="Estado"/>
                              </div>
                            </div>

                          </div>

                          <div class="row mb-2">


                            <div class="col-md-8">
                              <label for="endereco">Endereço</label>
                              <div class="position-relative">
                                <input
                                    id="endereco"
                                    type="text"
                                    v-model="clienteData.rua"
                                    class="form-control"
                                    :disabled="true"
                                    placeholder="Endereço"/>
                              </div>
                            </div>

                            <div class="col-md-4">
                              <label for="numero">Número</label>
                              <div class="position-relative">
                                <input
                                    id="numero"
                                    type="text"
                                    v-model="clienteData.numero"
                                    class="form-control"
                                    :disabled="true"
                                    placeholder="Número"/>
                              </div>
                            </div>

                          </div>

                          <div class="row mb-2">


                            <div class="col-md-4">
                              <label for="complemento">Complemento</label>
                              <div class="position-relative">
                                <input
                                    id="complemento"
                                    type="text"
                                    v-model="clienteData.compl"
                                    class="form-control"
                                    :disabled="true"
                                    placeholder="Complemento"/>
                              </div>
                            </div>

                            <div class="col-md-4">
                              <label for="bairro">Bairro</label>
                              <div class="position-relative">
                                <input
                                    id="bairro"
                                    type="text"
                                    v-model="clienteData.bairro"
                                    class="form-control"
                                    :disabled="true"
                                    placeholder="Bairro"/>
                              </div>
                            </div>

                            <div class="col-md-4">
                              <label for="nascim">Nascimento</label>
                              <div class="position-relative">
                                <input
                                    id="nascim"
                                    type="text"
                                    v-model="clienteData.nascim"
                                    class="form-control"
                                    :disabled="true"
                                    placeholder="Nascimento"/>
                              </div>
                            </div>



                          </div>



                          <div class="row mb-2">


                            <div class="col-md-8">
                              <label for="email">E-mail</label>
                              <div class="position-relative">
                                <input
                                    id="email"
                                    type="text"
                                    v-model="clienteData.email"
                                    class="form-control"
                                    :disabled="true"
                                    placeholder="E-mail"/>
                              </div>
                            </div>

                            <div class="col-md-4">
                              <label for="telefone">Telefone</label>
                              <div class="position-relative">
                                <input
                                    id="telefone"
                                    type="text"
                                    v-model="clienteData.tel1"
                                    class="form-control"
                                    :disabled="true"
                                    placeholder="Telefone"/>
                              </div>
                            </div>

                          </div>

                          <div class="row mb-2">


                            <div class="col-md-8">
                              <label for="emailnfe">E-mail NF-e</label>
                              <div class="position-relative">
                                <input
                                    id="emailnfe"
                                    type="text"
                                    v-model="clienteData.emailnfe"
                                    class="form-control"
                                    :disabled="true"
                                    placeholder="E-mail NF-e"/>
                              </div>
                            </div>

                            <div class="col-md-4">
                              <label for="celular">Celular</label>
                              <div class="position-relative">
                                <input
                                    id="celular"
                                    type="text"
                                    v-model="clienteData.celular"
                                    class="form-control"
                                    :disabled="true"
                                    placeholder="Celular"/>
                              </div>
                            </div>

                          </div>


                          <div class="row mb-2">

                            <div class="col-sm-12">
                              <div class="mb-3">
                                <label for="obs">Observações</label>
                                <textarea
                                    id="obs"
                                    v-model="clienteData.obs"
                                    type="text"
                                    rows="3"
                                    class="form-control"
                                    :disabled="true"
                                    placeholder="Observações"/>
                              </div>
                            </div>

                          </div>


                        </b-card-body>

                      </b-collapse>

                    </div>



                  </div>
                </div>
              </b-tab>


              <b-tab title="Pagamento (Shift+P)">
                <div>
                  <div class="row justify-content-center">


                    <div class="row mt-3">


                      <div class="col-sm-3">
                        <div class="mb-3 text-end">
                          <label for="subtotalpgto">Sub Total</label>
                          <input
                              id="subtotalpgto"
                              v-model="movPdvData.valorliq"
                              type="number"
                              class="form-control"
                              :disabled="true"
                              placeholder="Sub Total"/>
                        </div>
                      </div>

                      <div class="col-sm-3">
                        <div class="mb-3 text-end">
                          <label for="descontopgto">Desconto</label>
                          <input
                              id="descontopgto"
                              v-model="movPdvData.desconto"
                              type="number"
                              class="form-control"
                              :disabled="movPdvData.status !== 'EL'"
                              placeholder="Desconto"/>
                        </div>
                      </div>

                      <div class="col-sm-3">
                        <div class="mb-3 text-end">
                          <label for="totalvenda">Total da Venda</label>
                          <input
                              id="totalvenda"
                              v-model="movPdvData.totalvenda"
                              type="number"
                              class="form-control"
                              :disabled="true"
                              placeholder="Total da Venda"/>
                        </div>
                      </div>

                      <div class="col-sm-3">
                        <div class="mb-3 text-end">
                          <label for="trocodin">Troco em Dinheiro</label>
                          <input
                              id="trocodin"
                              v-model="movPdvData.trocodin"
                              type="number"
                              class="form-control"
                              :disabled="true"
                              placeholder="Troco em Dinheiro"/>
                        </div>
                      </div>

                    </div>

                    <div class="row mt-2">


                      <div class="col-md-6">
                        <div class="mb-3">
                          <label for="condpgtoPesq">Condição Pagamento</label>
                          <multiselect id="condpgtoPesq"
                                       ref="inputPesqCondPgto"
                                       @search-change="pesqCondPgto"
                                       @select="escolheuCondPgto"
                                       v-model="movPdvData.condpgto"
                                       placeholder="Pesquisar condição pagamento"
                                       :options="dtlistPesqCondPgto"
                                       :searchable="true"
                                       :disabled="movPdvData.status !== 'EL' || !movPdvData.id || !movPdvData.id === 0"
                                       label="descricao"
                                       class="multiselect-size form-control bg-light border-light rounded"
                                       track-by="descricao"
                                       value-prop="codigo">
                            <template #option="slotProps" v-if="dtlistPesqCondPgto">
                              <div class="row">
                                <div>
                                  <span class="text-info">
                                    {{ slotProps.option.codigo }}
                                  </span>
                                  <span class="mx-4" ></span>
                                </div>
                                <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                                <span class="mx-4" ></span><span class="mx-4" ></span>
                                <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>
                              </div>
                            </template>
                          </multiselect>
                        </div>
                      </div>


                      <div class="col-md-6">
                        <div class="mb-3">
                          <label for="formapgtoPesq">Forma Pagamento</label>
                          <multiselect id="formapgtoPesq"
                                       ref="inputPesqFormaPgto"
                                       @search-change="pesqFormaPgto"
                                       @select="escolheuFormaPgto"
                                       v-model="movPdvData.formapgto"
                                       placeholder="Pesquisar forma pagamento"
                                       :options="dtlistPesqFormaPgto"
                                       :searchable="true"
                                       :disabled="movPdvData.status !== 'EL' || !movPdvData.id || !movPdvData.id === 0"
                                       label="descricao"
                                       class="multiselect-size form-control bg-light border-light rounded"
                                       track-by="descricao"
                                       value-prop="codigo">
                            <template #option="slotProps" v-if="dtlistPesqFormaPgto">
                              <div class="row">
                                <div>
                                  <span class="text-info">
                                    {{ slotProps.option.codigo }}
                                  </span>
                                  <span class="mx-4" ></span>
                                </div>
                                <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                                <span class="mx-4" ></span><span class="mx-4" ></span>
                                <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>
                              </div>
                            </template>
                          </multiselect>
                        </div>
                      </div>



                    </div>

                    <div class="row mt-2">

                      <div class="col-sm-6">
                        <div class="mb-3">
                          <label for="vendedor">Vendedor</label>
                          <select
                              id="vendedor"
                              v-model="movPdvData.vendedor"
                              :disabled="true"
                              class="form-control">
                            <option value="01" selected>Vendedor 001</option>
                            <option value="02">Vendedor 002</option>
                          </select>
                        </div>
                      </div>

                      <div class="col-sm-6">
                        <div class="mb-3 text-end">
                          <label for="vlrfrete">Valor Frete</label>
                          <input
                              id="vlrfrete"
                              v-model="movPdvData.valorfrt"
                              type="number"
                              class="form-control"
                              :disabled="movPdvData.status !== 'EL'"
                              placeholder="Valor Frete"/>
                        </div>
                      </div>


                    </div>


                    <div class="row mt-2">

                      <div class="col-sm-12">
                        <label for="obs">Observações</label>
                        <textarea
                            id="obs"
                            v-model="movPdvData.obs"
                            type="text"
                            rows="2"
                            class="form-control"
                            :disabled="movPdvData.status !== 'EL'"
                            placeholder="Comentário"/>
                      </div>

                    </div>


                  </div>
                </div>
              </b-tab>


            </b-tabs>

<!--            -->
<!--            <h5 class="card-title mb-4">Cartão</h5>-->

<!--            <div class="card bg-primary text-white visa-card mb-0">-->
<!--              <div class="card-body">-->
<!--                <div>-->
<!--                  <i class="bx bxl-visa visa-pattern"></i>-->

<!--                  <div class="float-end">-->
<!--                    <i class="bx bxl-visa visa-logo display-3"></i>-->
<!--                  </div>-->

<!--                  <div>-->
<!--                    <i class="bx bx-chip h1 text-warning"></i>-->
<!--                  </div>-->
<!--                </div>-->

<!--                <div class="row mt-5">-->
<!--                  <div class="col-4">-->
<!--                    <p>-->
<!--                      <i class="fas fa-star-of-life m-1"></i>-->
<!--                      <i class="fas fa-star-of-life m-1"></i>-->
<!--                      <i class="fas fa-star-of-life m-1"></i>-->
<!--                    </p>-->
<!--                  </div>-->
<!--                  <div class="col-4">-->
<!--                    <p>-->
<!--                      <i class="fas fa-star-of-life m-1"></i>-->
<!--                      <i class="fas fa-star-of-life m-1"></i>-->
<!--                      <i class="fas fa-star-of-life m-1"></i>-->
<!--                    </p>-->
<!--                  </div>-->
<!--                  <div class="col-4">-->
<!--                    <p>-->
<!--                      <i class="fas fa-star-of-life m-1"></i>-->
<!--                      <i class="fas fa-star-of-life m-1"></i>-->
<!--                      <i class="fas fa-star-of-life m-1"></i>-->
<!--                    </p>-->
<!--                  </div>-->
<!--                </div>-->

<!--                <div class="mt-5">-->
<!--                  <h5 class="text-white float-end mb-0">12/25</h5>-->
<!--                  <h5 class="text-white mb-0">João da Silva</h5>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->



          </div>
        </div>


      </div>

      <div class="col-xl-6" v-if="updatingPdvItens">
        <Loader  style="min-height: 300px;">
        </Loader>
      </div>

      <div class="col-xl-6" v-if="!updatingPdvItens">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <table class="table align-middle mb-0 table-nowrap">
                <thead class="table-light">
                <tr>
                  <th>Produto</th>
                  <th>Descrição</th>
                  <th class="text-end">Valor</th>
                  <th class="text-end">Quantidade</th>
                  <th  class="text-end" >Total</th>
                  <th>Ações</th>
                </tr>
                </thead>
                <tbody>


                <tr v-for="prodPdv in movPdvItensData" :key="prodPdv.id">
                  <td>
                    <img  src="@/assets/images/product/bike_caloi.jpg"
                          alt="product-img"
                          title="product-img"
                          class="avatar-md"/>
                    </td>
                  <td>

                    <h5 class="font-size-14 text-truncate">
                      <router-link  to="/ecommerce/product-detail" class="text-dark text-wrap">
                        {{ prodPdv.descprod }}
                      </router-link>
                    </h5>

                    <p class="mb-0">
                      <span class="fw-medium">{{ prodPdv.obs }}</span>
                    </p>

                  </td>
                  <td class="text-end">R$ {{ formatDecimal(prodPdv.vlrunitliq) }}</td>
                  <td class="text-end">
                    {{ formatInteger(prodPdv.qtd) }}
                  </td>

                  <td class="text-end">R$ {{ formatDecimal(prodPdv.vlrtotalliq) }}</td>
                  <td>
                    <a href="javascript:void(0);"
                       @click="excluirItem(prodPdv.id)"
                       v-if="movPdvData.status === 'EL'"
                       class="action-icon text-danger">
                      <i class="mdi mdi-trash-can font-size-18"></i>
                    </a>
                  </td>
                </tr>
<!--                <tr>-->
<!--                  <td>-->
<!--                    <img-->
<!--                        src="@/assets/images/product/img-3.png"-->
<!--                        alt="product-img"-->
<!--                        title="product-img"-->
<!--                        class="avatar-md"-->
<!--                    />-->
<!--                  </td>-->
<!--                  <td>-->
<!--                    <h5 class="font-size-14 text-truncate">-->
<!--                      <router-link-->
<!--                          to="/ecommerce/product-detail"-->
<!--                          class="text-dark"-->
<!--                      >Produto Testes 0088</router-link-->
<!--                      >-->
<!--                    </h5>-->
<!--                    <p class="mb-0">-->
<!--                      Cor :-->
<!--                      <span class="fw-medium">Black</span>-->
<!--                    </p>-->
<!--                  </td>-->
<!--                  <td class="text-end">R$ 152,00</td>-->
<!--                  <td class="text-end">-->
<!--                    3-->
<!--                  </td>-->

<!--                  <td class="text-end">R$ 304,00</td>-->
<!--                  <td>-->
<!--                    <a-->
<!--                        href="javascript:void(0);"-->
<!--                        class="action-icon text-danger"-->
<!--                    >-->
<!--                      <i class="mdi mdi-trash-can font-size-18"></i>-->
<!--                    </a>-->
<!--                  </td>-->
<!--                </tr>-->
<!--                <tr>-->
<!--                  <td>-->
<!--                    <img-->
<!--                        src="@/assets/images/product/img-4.png"-->
<!--                        alt="product-img"-->
<!--                        title="product-img"-->
<!--                        class="avatar-md"-->
<!--                    />-->
<!--                  </td>-->
<!--                  <td>-->
<!--                    <h5 class="font-size-14 text-truncate">-->
<!--                      <router-link-->
<!--                          to="/ecommerce/product-detail"-->
<!--                          class="text-dark"-->
<!--                      >Produto Testes 0001</router-link-->
<!--                      >-->
<!--                    </h5>-->
<!--                    <p class="mb-0">-->
<!--                      Cor :-->
<!--                      <span class="fw-medium">Blue</span>-->
<!--                    </p>-->
<!--                  </td>-->
<!--                  <td class="text-end">R$ 145,00</td>-->
<!--                  <td class="text-end">-->
<!--                   4-->
<!--                  </td>-->

<!--                  <td class="text-end">R$ 290,00</td>-->
<!--                  <td>-->
<!--                    <a-->
<!--                        href="javascript:void(0);"-->
<!--                        class="action-icon text-danger"-->
<!--                    >-->
<!--                      <i class="mdi mdi-trash-can font-size-18"></i>-->
<!--                    </a>-->
<!--                  </td>-->
<!--                </tr>-->



                </tbody>
              </table>
            </div>
<!--            <div class="row mt-4">-->
<!--              <div class="col-sm-6">-->
<!--                <button-->
<!--                    @click="$router.go(-1)"-->
<!--                    class="btn btn-secondary"-->
<!--                >-->
<!--                  <i class="mdi mdi-arrow-left me-1"></i> Voltar-->
<!--                </button>-->
<!--              </div>-->
<!--              &lt;!&ndash; end col &ndash;&gt;-->
<!--              <div class="col-sm-6">-->
<!--                <div class="text-sm-end mt-2 mt-sm-0">-->
<!--                  <router-link to="/ecommerce/checkout" class="btn btn-success">-->
<!--                    <i class="mdi mdi-cart-arrow-right me-1"></i> Confirmar Pedido-->
<!--                  </router-link>-->
<!--                </div>-->
<!--              </div>-->
<!--              &lt;!&ndash; end col &ndash;&gt;-->
<!--            </div>-->
            <!-- end row-->
          </div>
        </div>
      </div>



      <div class="row">

        <div class="card">
          <div class="card-body">
            <!--            <h4 class="card-title mb-3">Resumo de Pedido</h4>-->



            <div class="row">

              <div class="col-sm-6">

                <button class="btn btn-outline-info"
                        @click="showModalCCaixa = true">
                  <i class="mdi mdi-box-shadow me-1"></i>
                  <span v-if="contaCaixaData && contaCaixaData.id > 0"> Caixa: {{ contaCaixaData.id }} </span>
                  <span v-else> Escolher Caixa </span>
                </button>

                <button class="btn btn-outline-danger ms-3"
                        v-if="movPdvData.id > 0 && movPdvData.valorliq > 0 && movPdvData.status === 'EL'"
                        @click="excluirVenda">
                  <i class="mdi mdi-trash-can me-1"></i> Cancelar Venda (Shift+Q)
                </button>

                <button class="btn btn-success ms-3"
                        v-if="movPdvData.id > 0 && movPdvData.valorliq > 0 && movPdvData.status === 'EL'"
                        @click="finalizarVenda">
                  <i class="mdi mdi-check-all me-1"></i> Finalizar Venda (Shift+Q)
                </button>

              </div>


              <div class="col-sm-6 text-end">


                <span>
                  <h2>Total</h2>
                  <h1> R$ {{ formatDecimal(movPdvData.valorliq + (movPdvData.valorfrt ?? 0.00)) }}</h1>
                </span>

              </div>



            </div>



            <!--            <div class="table-responsive">-->
            <!--              <table class="table mb-0">-->
            <!--                <tbody>-->
            <!--                <tr>-->
            <!--                  <td>Valor Total Bruto</td>-->
            <!--                  <td class="float-end">R$ 1.857,00</td>-->
            <!--                </tr>-->
            <!--                <tr>-->
            <!--                  <td>Desconto</td>-->
            <!--                  <td class="float-end">- R$ 157,00</td>-->
            <!--                </tr>-->
            <!--                <tr>-->
            <!--                  <td>Frete</td>-->
            <!--                  <td class="float-end">R$ 26,00</td>-->
            <!--                </tr>-->
            <!--                <tr>-->
            <!--                  <th>Valor Total</th>-->
            <!--                  <th class="float-end">R$ 1.744,22</th>-->
            <!--                </tr>-->
            <!--                </tbody>-->
            <!--              </table>-->
            <!--            </div>-->

          </div>
        </div>

      </div>




    </div>


    <b-modal size="xl" :title="`Conta Caixa: ${contaCaixaData.id !== undefined ? contaCaixaData.id : ''} (${nomeStatus(contaCaixaData.status)})`" v-model="showModalCCaixa" centered hide-footer>

      <div class="row">

        <div class="col-md-3">
          <div class="mb-3">
            <label for="valfatur">Valor Faturamento</label>
            <input
                id="valfatur"
                v-model="contaCaixaData.valfatur"
                type="text"
                class="form-control"
                :disabled="true"
                placeholder="Valor Faturamento"/>
          </div>
        </div>

        <div class="col-md-3">
          <div class="mb-3">
            <label for="valcusto">Valor Custo</label>
            <input
                id="valcusto"
                v-model="contaCaixaData.valcusto"
                type="text"
                class="form-control"
                :disabled="true"
                placeholder="Valor Custo"/>
          </div>
        </div>

        <div class="col-md-3">
          <div class="mb-3">
            <label for="vallucro">Valor Lucro</label>
            <input
                id="valcusto"
                v-model="contaCaixaData.vallucro"
                type="text"
                class="form-control"
                :disabled="true"
                placeholder="Valor Lucro"/>
          </div>
        </div>

        <div class="col-md-3">
          <div class="mb-3">
            <label for="perclucro">Lucro (%)</label>
            <input
                id="perclucro"
                v-model="contaCaixaData.perclucro"
                type="text"
                class="form-control"
                :disabled="true"
                placeholder="Lucro (%)"/>
          </div>
        </div>

      </div>


      <div class="row">



        <div class="col-md-3">
          <div class="mb-3">
            <label for="produtos">Total Produtos</label>
            <input
                id="produtos"
                v-model="contaCaixaData.produtos"
                type="text"
                class="form-control"
                :disabled="true"
                placeholder="Valor Lucro"/>
          </div>
        </div>

        <div class="col-md-3">
          <div class="mb-3">
            <label for="vendas">Total Vendas</label>
            <input
                id="vendas"
                v-model="contaCaixaData.vendas"
                type="text"
                class="form-control"
                :disabled="true"
                placeholder="Total Vendas"/>
          </div>
        </div>


      </div>



      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtinicio">Data Abertura</label>
            <input
                id="dtinicio"
                v-model="contaCaixaData.dtinicio"
                type="datetime-local"
                class="form-control"
                :disabled="true"
                placeholder="Data Abertura"/>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtfinal">Data Fechamento</label>
            <input
                id="dtfinal"
                v-model="contaCaixaData.dtfinal"
                type="datetime-local"
                class="form-control"
                :disabled="true"
                placeholder="Data Fechamento"/>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">


          <div class="text-end mt-5">

            <b-button variant="outline-danger"
                      v-if="contaCaixaData.id && contaCaixaData.status === 'AB'"
                      @click="fecharCaixa"
                      class="ms-2 me-2">
              <i class="bx bx-window-close font-size-16 align-middle me-2"></i>
              Fechar Caixa
            </b-button>


            <b-button variant="outline-warning" @click="abrirNovoCaixa" class="ms-2 me-2">
              <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
              Abrir Novo Caixa
            </b-button>

            <b-button variant="light" @click="showModalCCaixa = false" class="ms-2 me-2">
              <i class="bx bx-block font-size-16 align-middle me-2 ms-2"></i>
              Fechar
            </b-button>

          </div>
        </div>
      </div>

    </b-modal>


  </Layout>
</template>


<style>
.multiselect-size {
  --ms-max-height: 500px;
}
</style>
